import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { Currency } from '@zep/types';
import { fCurrency } from '../../../../utils';
import S from './PaymentInformation.module.scss';
const PaymentInformation = (props: PaymentInformationProps) => {
  const {
    t
  } = useTranslation(['business']);
  const {
    businessName,
    productName,
    price,
    content,
    vatAmount
  } = props;
  return <div className={S.wrapper} data-sentry-component="PaymentInformation" data-sentry-source-file="PaymentInformation.tsx">
      <div className={S.business_title}>{businessName}</div>
      <div className={S.information_content}>
        <div className={cns(S.information_row, S.no_margin_top)}>
          <div className={S.row_title}>
            {t('business:business_payments_product_name')}
          </div>
          <div>{productName}</div>
        </div>
        <div className={S.information_row}>
          {/* 가격 row는 공급가(VAT 전). vatAmount > 0(신정책 과세 건)이면
              'VAT 포함' 라벨이 금액 오해를 만들므로 'VAT 제외' 라벨을 쓴다 (Gate E).
              vatAmount=0(legacy/USD)은 기존 표기 유지. */}
          <div className={S.row_title}>
            {(vatAmount ?? 0) > 0 || props.currency !== 'KRW' ? t('business:businessPage.price.seperateVAT') : t('business:business_payments_product_price')}
          </div>
          <div>
            {fCurrency(price, props.currency, {
            position: 'pre',
            currencyString: '₩'
          })}
          </div>
        </div>
        {(vatAmount ?? 0) > 0 && <div className={S.information_row}>
            <div className={S.row_title}>
              {t('business:business_payments_vat')}
            </div>
            <div>
              {fCurrency(vatAmount as number, props.currency, {
            position: 'pre',
            currencyString: '₩'
          })}
            </div>
          </div>}
        <div className={S.information_row}>
          <div className={S.row_title}>
            {t('business:business_payments_product_content')}
          </div>
          <hr />
          {content ? <div className={S.normal_content_wrapper}>{content}</div> : <div className={S.premium_content_wrapper}>
              <div className={S.premium_content_item}>
                <div className={S.premium_content_item_title}>Basic</div>
                <div className={S.item_content}>
                  {t('business:businessPage.itemContent.basic')}
                </div>
              </div>
              <div className={S.premium_content_item}>
                <div className={S.premium_content_item_title}>Pro</div>
                <div className={S.item_content}>
                  {t('business:businessPage.itemContent.pro')}
                </div>
              </div>
              <div className={S.premium_content_item}>
                <div className={S.premium_content_item_title}>Enterprise</div>
                <div className={S.item_content}>
                  {t('business:businessPage.itemContent.enterprise')}
                </div>
              </div>
              <div className={S.premium_content_comment}>
                <p>{t('business:businessPage.itemNotice.one')}</p>
                <p>{t('business:businessPage.itemNotice.two')}</p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default PaymentInformation;
interface PaymentInformationProps {
  /** 공급가(VAT 전) — 서버 priceBeforeVat 또는 legacy price */
  price: number;
  businessName: string;
  productName: string;
  content?: string;
  currency: Currency;
  /** persisted/snapshot VAT 금액 — 0 또는 미존재면 VAT row 미노출 */
  vatAmount?: number;
}